export default __webpack_public_path__ + "static/media/for-players-worldwide.41eaee89.svg";